import React, {useCallback, useEffect, useRef, useState} from "react";
import useUserInfo from "../../routers/useUserInfo";
import {flatObj, getUuid, saveUserStorage, UserStorage} from "../../units";
import {useHistory} from "react-router-dom";
import useForm from "rc-form-hooks";
import {getSystemsCaptchaJpg, getSystemsCaptchaSms, postUserMobileModify} from "../../service";
import Input from "../../components/inputItem";
import {useLoading} from "../../components/loading/LoadingProvider";
import CountriesPicker from "../../components/countries";
import {useDispatch} from "react-redux";
import {userInfoAction} from "../../store/actions";

function ChangePhone() {

    const userData = useUserInfo()
    const [uuid, setUuid] = useState<string>(getUuid());
    const [captcha, setCaptcha] = useState<boolean>(false);
    const [captchaImage, setCaptchaImage] = useState<string>('');
    const [step, setStep] = useState<number>(59)
    const {goBack} = useHistory()
    const loading = useLoading()
    const codeRef = useRef("86")
    const dispatch = useDispatch()
    // const [mobile, setMobile] = useState<string>('')


    const {getFieldDecorator, validateFields, errors, values,setFieldsValue} = useForm<{
        original: string,
        current: string,
        captcha: string,
        captchaJpg: string,
    }>();

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        validateFields()
            .then(res => {
                if (!userData) {
                    return false
                }
                loading.showLoading()
                postUserMobileModify({
                    userId: userData.id,
                    captcha: res.captcha,
                    current: res.current,
                    areaCode: codeRef.current,
                    original: res.original
                }).then(data => {
                    if (data.code === 1) {
                        dispatch(userInfoAction(Object.assign({}, userData, {customerMobile: res.current.slice(0, 3) + "****" + res.current.slice(-4)})))
                        loading.showSuccess(null, () => {
                            goBack()
                        })
                    } else {
                        loading.showError(data.msg)
                    }
                }).catch(e => {
                    loading.showError()
                })
            })
            .catch(e => console.error(e.message));
    }, [values])

    useEffect(() => {
        // 60s倒计时
        if (captcha) {
            const id = setInterval(() => {
                setStep(c => {
                    if (c - 1 === 0) {
                        clearInterval(id)
                        setCaptcha(false)
                        return 59
                    }
                    return c - 1
                })
            }, 1000)
            return () => clearInterval(id)
        }
    }, [captcha])

    const captchaHandle = useCallback(() => {
        // console.log(values)

        if (userData && values.captchaJpg && values.current && !captcha) {
            // 发送手机验证码
            loading.showLoading('发送中')
            getSystemsCaptchaSms({
                uuid,
                captcha: values.captchaJpg,
                areaCode: codeRef.current,
                mobile: values.current
            }).then(res => {
                if (res.code === 1) {
                    setCaptcha(true)
                    loading.showSuccess('发送成功')
                } else {
                    loading.showError(res.msg)
                }
            }).catch(e => {
                loading.showError()
            })
        }
    }, [uuid, values, captcha])


    useEffect(() => {
        // 监听uuid变化 ，更新图片验证码
        getSystemsCaptchaJpg({
            uuid
        }).then(res => {
            if (res.code === 1) {
                setCaptchaImage(res.data)
                setFieldsValue({'captchaJpg':'','captcha':''})
                setCaptcha(false)
            } else {
                loading.showError(res.msg)
            }
        })
    }, [uuid])

    const captchaImageHandle = () => {
        // 判断是否发送验证码，已发送 停止更新 uuid
        if (!captcha) {
            setUuid(getUuid())
        }
    }


    return <div className="change-phone">
        <h3>当前绑定手机号：<span>{userData?.customerMobile}</span></h3>

        <form onSubmit={handleSubmit}>

            {
                getFieldDecorator('original', {
                    rules: [{required: true, message: '请输入新的手机号'}]
                })(<Input label='原 手 机' type={'number'} placeholder='请输入新的手机号'
                          clear/>)
            }

            <div className="flex">
                <div className="common-input-box">
                    <CountriesPicker label={"+"} onChange={(code) => codeRef.current = code.areaCode}/>
                </div>
                {
                    getFieldDecorator('current', {
                        rules: [{required: true, message: '请输入新手机号'}]
                    })(<Input type={'text'} placeholder='请输入新手机号' extraClass={['no-padding-left']} clear/>)
                }
            </div>


            {
                getFieldDecorator('captchaJpg', {
                    rules: [{required: true, message: '请输入识别码'}]
                })(<Input label='识 别 码' type={'text'} placeholder='请输入识别码'>
                    <div className="captchaImage" onClick={captchaImageHandle}>
                        <img src={captchaImage} alt=""/>
                    </div>
                </Input>)
            }

            {
                getFieldDecorator('captcha', {
                    rules: [{required: true, message: '请输入短信验证码'}]
                })(<Input label='验 证 码' type={'text'} placeholder='请输入验证码'>
                    <div className="captcha" onClick={captchaHandle}>
                        {
                            captcha ? <p>{step}s重新发送</p> : <p>发送验证码</p>
                        }

                    </div>
                </Input>)
            }

            <button type={'submit'} className="common-btn submit">确认更改</button>
        </form>
    </div>
}

export default ChangePhone
